import { add } from "date-fns";
import Cookies from "universal-cookie/es6";

import { LANGUAGES } from "../components/LocalizationMenu/constants";

import { i18n } from "../i18n";

export const cookies = new Cookies();

export const formatLanguageValue = (language: string): string => {
  return language === LANGUAGES.ru ? "ru-RU" : "en-EN";
};

export const setLanguageCookie = (language: string) => {
  const languageCookieValue = formatLanguageValue(language);

  cookies.set(".AspNetCore.Culture", `c=${languageCookieValue}|uic=${languageCookieValue}`, {
    path: "/",
    expires: add(new Date(), { years: 1 }),
  });
};

if (!cookies.get(".AspNetCore.Culture")) {
  setLanguageCookie(i18n.language);
}
